export enum OutsideTecnicalInfoMainDistributionType {
  Ondergronds,
  Gevel,
}
